import {
  RAN_DB_UPLOAD_EXCEL_WITH_PROGRESS,
  RAN_DB_UPLOAD_STATUS,
} from '../../../common/constants/constants';
import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

const POLL_INTERVAL_MS = 500;

/**
 * Upload RAN DB Excel with progress: starts job, polls for progress, returns final result.
 * @param {FormData} formData - FormData with 'file' key
 * @param {Object} onProgress - callback({ progress, stage, message })
 * @returns {Promise<{ result: Object }>}
 */
export const uploadRanDbExcelFileWithProgress = async (formData, onProgress) => {
  const response = await apiClient.post(RAN_DB_UPLOAD_EXCEL_WITH_PROGRESS, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  const data = response?.data?.response ?? response?.data;
  const jobId = data?.jobId;
  if (!jobId) {
    throw new Error('Server did not return a job ID');
  }

  if (onProgress) {
    onProgress({ progress: 0, stage: 'Starting...', message: 'Upload started' });
  }

  return new Promise((resolve, reject) => {
    const poll = async () => {
      try {
        const statusRes = await apiClient.get(RAN_DB_UPLOAD_STATUS(jobId));
        const statusData = statusRes?.data?.response ?? statusRes?.data;
        const { status, progress, stage, message, result, error } = statusData ?? {};

        if (onProgress) {
          const p = typeof progress === 'number' ? progress : 0;
          onProgress({ progress: p, stage: stage ?? '', message: message ?? '' });
        }

        if (status === 'completed') {
          resolve({ result });
          return;
        }
        if (status === 'failed') {
          reject(new Error(error || 'Upload failed'));
          return;
        }

        setTimeout(poll, POLL_INTERVAL_MS);
      } catch (err) {
        handleApiError(err);
        reject(err);
      }
    };

    poll();
  });
};
